import { memo, type ReactNode } from 'react'

import { LoginForm } from '@userfront/react'

import { content_flash_detector } from '@repo/common/helpers/content_flash_detector'
import { useAuth } from '@repo/common/queries/auth'

export { content_flash_detector }

export const RequireLogin = memo<{
  children: ReactNode
}>(function RequireLogin({ children }) {
  const { data, isSuccess } = useAuth()

  if (isSuccess == false) {
    return null
  }

  if (data.is_authenticated) {
    return children
  }

  content_flash_detector.content_has_been_shown()

  return <LoginForm />
})
